import Vue from "vue";
import Vuex from "vuex";

import ui_store, { UiState } from "./modules/ui.store";
import auth_store, { AuthState } from "./modules/auth.store";
import hirarchy_store, { HirarchyState } from "./modules/hirarchy.store";
import gateway_store, { GatewayState } from "./modules/gateway.store";
import schedule_store, { ScheduleState } from "./modules/schedule.store";

Vue.use(Vuex);

export interface State {
    ui: UiState;
    auth: AuthState;
    hirarchy: HirarchyState;
    gateway: GatewayState;
    schedule: ScheduleState;
}

export default new Vuex.Store<State>({
    modules: {
        ui: ui_store,
        auth: auth_store,
        hirarchy: hirarchy_store,
        gateway: gateway_store,
        schedule: schedule_store,
    },
});
